import { useEffect, useState } from 'react';
import { globalEmitter } from '../helpers/emitter';
import { openModal } from "../helpers/useModal";
import { type_GM_STATE } from "../../helpers";
import { HeartIcon } from '../icons/HeartIcon'

type props = {
  productId: number
  productHandle: string | null
  productTemplate: string | null
}

declare var GM_STATE: type_GM_STATE

export function WishlistItem({ productId, productHandle, productTemplate }: props) {
  const { redirect, ignore } = GM_STATE.wishlist.productTemplates
  const [currentList, setCurrentList] = useState(null)
  if (!productId || !productHandle) {
    return
  }

  const isRedirectTemplate = productTemplate && redirect.includes(productTemplate)
  const isIgnoreTemplate = productTemplate && ignore.includes(productTemplate)
  if (isIgnoreTemplate) return

  const wishlistSlideoutEl = document.querySelector('.js-wishlist-product-slideout')

  const handleClick = () => {
    if (isRedirectTemplate) {
      location.href = `/products/${productHandle}`
    } else {
      openSlideout()
    }
  }

  const openSlideout = () => {
    wishlistSlideoutEl?.setAttribute('product-id', productId.toString())
    wishlistSlideoutEl?.setAttribute('product-handle', productHandle)
    productTemplate && wishlistSlideoutEl?.setAttribute('product-template', productTemplate)
    openModal('wishlist-product-slideout')
  }

  useEffect(() => {
    globalEmitter.on('fetchWishlist', (lists) => {
      if (lists?.length > 0) {
        const itemList = lists.find((list: any) => list.items.some((item: any) => item?.meta?.handle === productHandle))
        setCurrentList(itemList)
      }
    })
  }, [productHandle, currentList])

  useEffect(() => {
    if (GM_STATE.customer.logged) {
      const wishlistGlobal = sessionStorage.getItem('wishlistsGlobal')

      if (wishlistGlobal && JSON.parse(wishlistGlobal).length > 0) {
        const itemList = JSON.parse(wishlistGlobal).find((list: any) => list.items.some((item: any) => item?.meta?.handle === productHandle))
        setCurrentList(itemList)
      }
    }
  }, [])

  return (
    <button className="wishlist_icon" type="button" onClick={handleClick}>
      <HeartIcon className={currentList ? 'fill-ink' : 'text-subdued'} />
    </button>
  )
}
